import { SelectOption } from "rivals/components/shared/Form/Select/types";
import { ELIGIBILITY_YEAR_LABELS } from "rivals/shared/constants";
import { CollegeTransfer } from "rivals/shared/interfaces/Athlete";
import { EXIT_TYPES } from "../interfaces/Transfer";

const AUGUST = 8;

export const getAllAthleticYearsOptions = (): SelectOption<string>[] => {
  return Object.values(ELIGIBILITY_YEAR_LABELS).map(item => ({
    name: `${item}`.toUpperCase(),
    value: `${item}`.toLowerCase()
  }));
};

export const getCurrentTransferYear = (): number => {
  const year = new Date().getFullYear();
  const month = new Date().getMonth() + 1;
  return month >= AUGUST ? year + 1 : year;
};

export const getLatestTransfer = (
  transfers?: CollegeTransfer[]
): CollegeTransfer | null => {
  const currentTransferYear = getCurrentTransferYear();

  if (transfers?.length) {
    const currentYearTransfers = transfers.filter(
      transfer => transfer.classYear === currentTransferYear
    );
    const sortedTransfers = currentYearTransfers.sort((a, b) => {
      const aTime = new Date(a.createdAt as string).getTime();
      const bTime = new Date(b.createdAt as string).getTime();
      return bTime - aTime; // from latest to earliest
    });

    return sortedTransfers[0]; // latest
  }

  return null;
};

/**
 * The following function receives the latest transfer record
 * used to check if college player is outside the transfer (never entered, withdrew, or entered and never signed)
 * @param lastTransfer of type CollegeTransfer
 * @returns false if transfer exitType is `TRANSFERRED`
 * false if player still in the portal (entryType is either `ENTERED` or `INTENT`) and not exitType
 * true if there isn't a transfer to check (lastTransfer was falsy)
 * true if transfer exitType is `WITHDREW`
 * true if transfer exitType is `NOT_SIGNED`
 */
export const athleteOutsideTransferPortal = (
  lastTransfer: CollegeTransfer | null
): boolean => {
  return (
    !lastTransfer ||
    lastTransfer.exitType === EXIT_TYPES.WITHDREW ||
    lastTransfer.exitType === EXIT_TYPES.NOT_SIGNED
  );
};
